// services/AuthService.js - Keep exactly as is
import client from "../api/axios";
import ENDPOINTS from "../api/apis";

const authService = {
  login: async (credentials) => {
    const response = await client.post(ENDPOINTS.auth.login, credentials);
    return response.data; 
  },
  
  register: async (userData) => {
    const response = await client.post(ENDPOINTS.auth.register, userData);
    return response.data;
  },
  
  verifyToken: async () => {
    const token = localStorage.getItem("token");
    if (!token || token === "undefined" || token === "null") {
      throw new Error("No valid token found");
    }
    const response = await client.get(ENDPOINTS.auth.verify);
    return response.data;
  },
};

export default authService;
